<template>
  <cc-container>
    <cc-header-nav title="我的账款">
      <template slot="right">
        <div  class="ellipsis">
          <van-icon
            class="ellipsis-icon"
            name="ellipsis"
            @click.stop="isShowSmallNav = !isShowSmallNav"
          />
        </div>
      </template>
    </cc-header-nav>
    <cc-main>
      <cc-pull-refresh style="min-height:100%" :disabled="list.length===0" v-model="isLoading" @refresh="onRefresh">
      <ul class="card" v-if="+is_display_credit === 1">
        <li class="card1 card-item">
          <div class="price">{{repayment_date || '--'}}</div>
          <p class="txt">本期还款日</p>
        </li>
        <li class="card2 card-item">
          <div class="price"><b>￥</b>{{used_quota}}</div>
          <p class="txt">本期待还账款</p>
        </li>
        <li class="card3 card-item">
          <div class="price"><b>￥</b>{{usable_quota}}</div>
          <p class="txt">本期可用额度</p>
        </li>
        <li class="card4 card-item">
          <div class="price"><b>￥</b>{{total_quota}}</div>
          <p class="txt">总额度</p>
        </li>
      </ul>
      <div class="credit-title mt10">
        <span class="icon"></span>
        账期订单
      </div>
        <div class="no-data" v-if="list.length === 0 || +is_display_credit === 0">
          <img :src="require('@/assets/img/management/credit-no-data.png')" alt="">
          <p>亲，暂无相关订单哦~</p>
        </div>
        <van-list
          v-else
          class="list"
          v-model="m_loading"
          :finished="m_finished"
          :finished-text="m_finishedText"
          @load="mHandlePullUpLoadMore"
          :immediate-check="m_immediateCheck"
        >
          <div class="list-item" v-for="item in list" :key="item.id">
            <p class="order-number">单号：{{item.order_number}}</p>
            <div class="info">
              <div class="money">金额：<span class="price"><b>{{+item.type === 1 ? '+' : '-'}}￥</b>{{item.amount}}</span></div>
              <div class="time">时间：{{item.create_time}}</div>
            </div>
          </div>
        </van-list>
      </cc-pull-refresh>
    </cc-main>
    <cc-small-nav v-model="isShowSmallNav"/>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { Icon, List } from 'vant'
import { requestMyCredit } from '../../../fetch/manage-center/my-credit'
import ListMixin from '@/mixins/list'
Vue.use(Icon).use(List)
export default {
  name: 'my-credit',
  mixins: [ListMixin],
  components: {},
  data () {
    return {
      list: [],
      isLoading: false,
      isShowSmallNav: false,
      repayment_date: '', // 本期还款日
      used_quota: '', // 本期代还账款
      total_quota: '', // 总额度
      usable_quota: '', // 本期可用额度
      is_display_credit: ''// 是否授信
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onRefresh () {
      this.mReset()
      this.loadData(true)
    },
    async loadData (reset) {
      this.mRequest()
      const res = await requestMyCredit({
        page: this.m_page.curr,
        limit: this.m_page.limit
      })
      this.$tips(res, {
        tip: false
      }, res => {
        this.isLoading = false
        const data = res
        this.repayment_date = data.repayment_date
        this.used_quota = data.used_quota
        this.total_quota = data.total_quota
        this.usable_quota = data.usable_quota
        this.is_display_credit = data.is_display_credit
        if (data.credit_order_list.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          if (reset) {
            this.list = data.credit_order_list
          } else {
            this.list = [...this.list, ...data.credit_order_list]
          }
        }
      })
      this.mSuccess()
    }
  }
}
</script>

<style scoped lang="scss">
  .ellipsis{
    width: 50%;
    height: 100%;
    @include center();
    &-icon{
      transform: rotate(90deg);
    }
  }
  .credit-title{
    color: #343434;
    font-size: 15px;
    margin-left: 10px;
    font-weight: bold;
    .icon{
      display: inline-block;
      width: 3px;
      height: 14px;
      background: #EE1F21;
      border-radius: 1px;
      margin-right: 10px;
    }
  }
  .card{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 10px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &-item{
      width: 172px;
      height: 75px;
      margin-bottom: 10px;
      background-size: 100%;
      box-sizing: border-box;
      padding: 13px 0 0 5px;
      box-sizing: border-box;
      color: #ffffff;
      .price{
        font-size:18px;
        b{
          font-size: 12px;
        }
      }
      .txt{
        font-size: 10px;
      }
    }
  }
  @for $i from 1 through 4 {
    .card#{$i} {
      background-image: url("~@/assets/img/management/mycredit-card#{$i}.png");
    }
  }
  .list{
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    &-item{
      width: 355px;
      height: 83px;
      box-sizing: border-box;
      padding: 15px 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 10px;
      .order-number{
        color: #565656;
        font-size: 15px;
        font-weight: bold;
      }
      .info{
        display: flex;
        justify-content: space-between;
        .money{
          color:#666666;
          font-size: 12px;
          .price{
            b{
              font-size: 12px;
            }
            color: #EC2020;
            font-size: 18px;
          }
        }
        .time{
          color: #666666;
          font-size: 12px;
        }
      }
    }
  }
  .no-data{
    width: 100%;
    display: flex;
    margin-top: 40px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img{
      display: inline-block;
      width: 160px;
    }
    p{
      text-align: center;
      color: #565656;
      font-size: 12px;
      margin-top: 20px;
    }
  }
</style>
